import styled, { css } from 'styled-components';

export const ExperienceContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
`;

export const ExperienceWrapper = styled.div`
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  padding: 72px 50px;

  @media screen and (max-width: 786px) {
    padding: 48px 20px;
  }
`;

export const Experiences = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 48px;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    grid-column-gap: 24px;
  }
`;

export const ExperienceCard = styled.div`
  background: ${({ isFirst }) => (isFirst ? '#fff' : '#010606')};
  border-radius: 10px;
  padding: 24px;
  width: 100%;
  height: 100%;
  transition: all 0.2s ease-in-out;
  position: relative;
  color: ${({ isFirst }) => (isFirst ? '#010606' : '#fff')};
  border: 1px solid ${({ isFirst }) => (isFirst ? '#010606' : '#fff')};

  &:hover {
    background: transparent;
    border: 1px solid #010606;
    color: #010606;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }

  @media screen and (max-width: 768px) {
    padding: 8px;
    border-radius: 4px;
  }
`;
export const ExperienceH1 = styled.h1`
  font-size: 2.5rem;
  color: #010606;
  margin-bottom: 32px;
  text-align: center;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const ExperienceH2 = styled.h2`
  font-size: 1rem;
  margin-bottom: 0px;
`;

export const ExperienceH3 = styled.h3`
  font-size: 0.8rem;
  font-weight: 400;
  margin-bottom: 0px;
`;

export const ExperienceH4 = styled.h4`
  font-size: 0.75rem;
  font-weight: 400;
  margin-bottom: 0px;
`;

export const ExperienceDesc = styled.ul`
  margin-top: 10px;
  margin-left: 20px;

  > li {
    font-size: 0.9rem;
    margin-top: 4px;
  }
`;

export const VerticalBar = styled.div`
  width: 2px;
  height: calc(100% + 2px);
  position: absolute;
  top: 0;
  background-color: #010606;

  ${({ isRight }) =>
    isRight
      ? css`
          left: -26px;

          @media screen and (max-width: 768px) {
            left: -14px;
          }
        `
      : css`
          right: -26px;

          @media screen and (max-width: 768px) {
            right: -14px;
          }
        `}

  ${({ isLast, isFirst }) =>
    isLast
      ? css`
          height: calc(50% + 1px);
        `
      : isFirst
      ? css`
          height: calc(50% + 1px);
          top: calc(50% + 1px);
        `
      : null}
`;

export const CircleDot = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  position: absolute;
  top: calc(50% - 16px);

  ${({ isRight }) =>
    isRight
      ? css`
          left: -41px;

          @media screen and (max-width: 768px) {
            left: -23px;
          }
        `
      : css`
          right: -41px;

          @media screen and (max-width: 768px) {
            right: -23px;
          }
        `}

  ${({ isFirst }) =>
    isFirst
      ? css`
          background-color: #fff;
          border: 3px solid #010606;
        `
      : css`
          background-color: #010606;
          border: 3px solid #fff;
        `}

  @media screen and (max-width: 768px) {
    width: 20px;
    height: 20px;
    border: 2px solid #010606;
    top: calc(50% - 10px);
  }
`;
